<template>
  <td :class="[
    'px-3 py-2 whitespace-nowrap',
    !noTextColor && 'text-gray-700 dark:text-dark-50',
    customClass
  ]" :colspan="colspan">
    <slot></slot>
  </td>
</template>

<script>
export default {
  name: 'TableCell',
  props: {
    noTextColor: {
      type: Boolean,
      default: false
    },
    colspan: {
      type: Number,
      default: 1
    },
    customClass: {
      type: String,
      default: ''
    }
  }
}
</script>
